import React, { useEffect, useState } from "react";
import "@Styles/mandate.css";
import Heading from "../Common/MainHeading";
import { HEADING_NOTIFICATION } from "../Common/constant";
import { connect } from "react-redux";
import { withRouter } from "../../../hooks/withRouter";
import { getNotification, postNotification } from "../../../Redux/ApplyLoan/action";
import Modal from "react-bootstrap/Modal";
import LoanHistoryNoData from "./LoanHistoryNoData";
import ToastMsg from "../../../helper/ToastMsg";
import { Loader } from "../Common/Loader";


function NotificationModal(props) {
  const handleClick = () => {
    props.notiificationPopUp(); 
  
    const title = props?.notificationData?.title;
  
  
    if (
      title === "400 coins waiting for you." ||
      title === "400 coins credited to your wallet."
    ) {
      window.location.href = "/super-loan-dashboard";
    }
  };

  
  
  
  return (
   <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="custom-centered-modal"
    >
      <Modal.Body
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div className="modelstyle">
          <h3 className="modelheading2 notificationheading">{props?.notificationData?.title}</h3>
          <p className="notificationcontent">{props?.notificationData?.body}</p>
          <div
            className="notificationOkBtn"
            onClick={handleClick}
          >
            OK
          </div>
        </div>
      </Modal.Body>
    </Modal>
  
  );
}

const Notification = (props) => {
  // console.log(props, "propsin Notification");
  let token = props?.user?.User?.token||localStorage.getItem("gpay_token");
  const [notificationData, setNotificationData] = useState([]);
  const [id, setId] = useState(null);
  const [notificationId, setNotificationId] = useState();
  const [notificationShow, setNotificationShow] = React.useState(false);
  const [isRead, setIsRead] = useState(true);
  const[loader,setLoader]=useState(false)
  const [hasReadNotification, setHasReadNotification] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    handleNotification();
  }, []);
  

  useEffect(() => {
    props
    .getNotification(token)
      .then(res => {
        const allRead = res?.data.every(notification => notification?.read === true);
        setHasReadNotification(allRead);
      })
      .catch(error => {
        console.error('Error fetching notifications:', error);
      });
  }, [getNotification, token]);
  
  // console.log(hasReadNotification, "hasReadNotification");






  const handleNotification = () => {
    setLoader(true)
    props
      .getNotification(token)
      
      .then((res) => {
        setLoader(false)
        setNotificationData(res?.data);
        for (let i = 0; i < res.data.length; i++) {
          if (!res.data[i].read) {
            localStorage.setItem("notificationBell", true);
            break;
          } else {
            localStorage.setItem("notificationBell", false);
          }
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };
  const handlePostNotification = (id) => {
    let data = { notification_id: notificationId };
    setLoader(true)
    props
      .postNotification(token, data)
      .then((res) => {
        setLoader(false)
        handleNotification();
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };
  const notiificationPopUp = () => {
    if (!isRead) {
      handlePostNotification(id);
    }
    setNotificationShow(false);
  };
  
  return (
    <div id="background" className="main_div ">
      {loader?<Loader/>:null}
      <div id="background" className="">
        {notificationData.length > 0 ? (
          <div className="pb-4 toolbarRespo">
            
            
            <div className="shadowlinepurebottomnew  sticky-header"> 
            <Heading
              headingText={HEADING_NOTIFICATION}
              backprops={"/DummyDashboard"}
              history={props.history}
            />
            </div>
            <span style={{opacity:0}}>sdjfk</span>
            <div id="background" className="wrapper-content notificationfix">
              {notificationData.map((item, index) => {

              const text = item?.body.slice(0, 30);
              const formattedText = text.split(',').join(',');
              

              const formatDate = (dateString) => {
                const date = new Date(dateString);
                
                const pad = (num) => num.toString().padStart(2, '0');
                
                const day = pad(date.getDate());
                const month = pad(date.getMonth() + 1); 
                const year = date.getFullYear();
                
                let hours = date.getHours();
                const minutes = pad(date.getMinutes());
                const isPM = hours >= 12;
                hours = hours % 12 || 12; 
                const formattedHours = pad(hours);
                const ampm = isPM ? 'PM' : 'AM';
                
                return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
              };
              const formattedDate = formatDate(item?.created_at);

                return (
                  <div
                    key={index}
                    className="card-height-small mb-20 notification-width mx-auto bg-white notificationbox"
                  >
                <div style={{marginBottom:"15px"}} className="d-flex flex-column justify-content-between">
                      <div
                      style={{paddingLeft:"20px", marginTop:"20px", marginBottom:"10px"}}
                        className={
                          item?.read
                            ? "pt-0 pb-0 notification blur"
                            : "pt-0 pb-0 notification"
                        }
                        onClick={() => {
                          setId(index);
                          setIsRead(item?.read);
                          setNotificationId(item?.id);
                          setNotificationShow(true);
                        }}
                      >
                        <span className="n-head mbottom-5">
                          <strong>{item?.title}</strong>
                        </span>
                        <span className="n-body">
                          <p style={{ whiteSpace: 'pre-wrap' }} className="notify-content mb-5px">{formattedText}...</p>
                        </span>
                        <span className="n-dt">{formattedDate}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <LoanHistoryNoData
            text="Oops!! You don't have any notification"
            PageText="Notification"
            history={props.history}
          />
        )}
      </div>
      <NotificationModal
        show={notificationShow}
        notiificationPopUp={notiificationPopUp}
        notificationData={notificationData[id]}
        onHide={() => setNotificationShow(false)}
        redirectOnOk={notificationData[id]?.title} 
        user={props.user} 
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps, { getNotification, postNotification })(
  Notification
));
